
"use client";
// import React from 'react'
// import Reveal from "./Reveal";


// const Fees = () => {
//     const fees = [
//         { label: "Application Fee", amount: "₹5,000", note: "One-time, non-refundable", color: "#0475B3" },
//         { label: "Admission Fee", amount: "₹10K–₹20K", note: "Paid upon selection", color: "#F47721" },
//         { label: "Annual Fee", amount: "₹1.25L–₹1.95L", note: "Per academic year", color: "#0475B3" },
//         { label: "Examination Fee", amount: "₹30,000", note: "At thesis submission", color: "#F47721" },
//     ];
//     return (
//         <section id="fees" className="py-14 md:py-20 bg-[#081E2D] relative overflow-hidden">
//             <div className="absolute inset-0">
//                 <img src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1400&h=600&fit=crop&auto=format"
//                     alt="" className="w-full h-full object-cover opacity-5" />
//             </div>
//             <div className="relative max-w-(--max-page-width) px-(--container-padding) mx-auto ">
//                 <Reveal className="text-center mb-12">
//                     <div className="flex items-center justify-center gap-2 mb-3">
//                         <div className="w-8 h-0.5 bg-[#FFA201]" />
//                         <span className="text-[#FFA201] text-xs font-black uppercase tracking-widest">Programme Fees</span>
//                         <div className="w-8 h-0.5 bg-[#FFA201]" />
//                     </div>
//                     <h2 className="text-4xl font-black text-white mb-2">Transparent Fee Structure</h2>
//                     <p className="text-blue-300 text-md">Designed for internal scholars and working professionals alike.</p>
//                 </Reveal>

//                 <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
//                     {fees.map((f, i) => (
//                         <Reveal key={f.label} delay={i * 80}>
//                             <div className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 text-center">
//                                 <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4"
//                                     style={{ backgroundColor: `${f.color}30` }}>
//                                     <span className="text-xl">💰</span>
//                                 </div>
//                                 <div className="text-2xl font-black mb-1" style={{ color: f.color === "#0475B3" ? "#60a5fa" : "#FFA201" }}>{f.amount}</div>
//                                 <div className="text-white font-bold text-md mb-1">{f.label}</div>
//                                 <div className="text-blue-400 text-sm">{f.note}</div>
//                             </div>
//                         </Reveal>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// }

// export default Fees

"use client";
import React from 'react'
import Reveal from "./Reveal";

const Fees = () => {
    const feeGroups = [
        {
            title: "One-time fees",
            items: [
                { label: "Application Fee", amount: 5000 },
                { label: "Admission Fee", amount: 20000 },
                { label: "Security Deposit", amount: 25000 },
            ],
        },
        {
            title: "Annual fees",
            items: [
                { label: "1st Year Annual Fee", amount: 195000 },
                { label: "2nd Year Annual Fee", amount: 195000 },
                { label: "3rd Year Annual Fee", amount: 195000 },
            ],
        },
        {
            title: "Final-stage fees",
            items: [
                { label: "Synopsis Approval Fee", amount: 5000 },
                { label: "Examination Fee", amount: 30000 },
                { label: "Submission Fee", amount: 5000 },
            ],
        },
    ];

    const total = feeGroups
        .flatMap((g) => g.items)
        .reduce((sum, f) => sum + f.amount, 0);

    const formatINR = (n) =>
        new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        }).format(n);

    return (
        <section id="fees" className="py-14 md:py-20 bg-[#081E2D] relative overflow-hidden">
            <div className="absolute inset-0">
                <img
                    src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1400&h=600&fit=crop&auto=format"
                    alt=""
                    className="w-full h-full object-cover opacity-5"
                />
            </div>
            <div className="relative max-w-(--max-page-width) px-(--container-padding) mx-auto">
                <Reveal className="text-center mb-12">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                        <span className="text-[#FFA201] text-xs font-black uppercase tracking-widest">
                            Programme Fees
                        </span>
                        <div className="w-8 h-0.5 bg-[#FFA201]" />
                    </div>
                    <h2 className="text-4xl font-black text-white mb-2">Transparent Fee Structure</h2>
                    <p className="text-blue-300 text-md">
                        Designed for internal scholars and working professionals alike.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {feeGroups.map((group, gIdx) => (
                        <Reveal key={group.title} delay={gIdx * 120}>
                            <div className="bg-white/5 border border-white/10 rounded-md overflow-hidden h-full">
                                <div className="bg-linear-to-r from-[#0475B3] to-[#03608f] px-4 py-3">
                                    <span className="text-white text-lg font-black uppercase tracking-widest">
                                        {group.title}
                                    </span>
                                </div>
                                <table className="w-full text-left border-collapse">
                                    <tbody>
                                        {group.items.map((f, i) => (
                                            <tr
                                                key={f.label}
                                                className={`border-b border-white/10 last:border-b-0 hover:bg-white/10 transition-colors duration-200 ${i % 2 === 0 ? "bg-white/2" : ""
                                                    }`}
                                            >
                                                <td className="px-4 py-3 text-white text-md font-medium">
                                                    {group.title === "Annual fees" ? `${f.label}*` : f.label}
                                                </td>
                                                <td className="px-4 py-3 text-right text-[#FFA201] font-black text-md whitespace-nowrap">
                                                    {formatINR(f.amount)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={feeGroups.length * 120}>
                    <div className="flex items-center justify-between bg-linear-to-r from-[#0475B3] to-[#03608f] rounded-md px-5 py-4 mt-5">
                        <span className="text-white font-black uppercase tracking-widest text-sm">
                            Total programme fee
                        </span>
                        <span className="text-[#FFA201] font-black text-2xl whitespace-nowrap">
                            {formatINR(total)}
                        </span>
                    </div>
                </Reveal>
                <Reveal delay={feeGroups.length * 120 + 100}>
                    <p className="text-white/70 text-md mt-4 text-center ">
                        *Note: The period may be extended in the event of continued non-compliance.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default Fees;